<div class="auth-page">
  <div
    class="d-flex flex-fill auth-page-item flex-column align-items-center pr-3 pl-3 justify-content-center pt-3 pb-3"
  >
    <router-outlet></router-outlet>
  </div>

  <div class="auth-page-footer">
    <div class="auth-page-footer-content">
      <a href="#" class="auth-page-link text-decoration-none">Privacy Policy</a>
      <a href="#" class="auth-page-link text-decoration-none"
        >Terms & Conditions</a
      >
      <a href="#" class="auth-page-link text-decoration-none"
        >Security Notice</a
      >
    </div>
  </div>
</div>
